/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

import { BUTTON_GRADIENT } from './colors';

export const FONT_FAMILY = {
  heading: `"Rouge Script", cursive;`,
  subHeading: `'Sorts Mill Goudy', serif;`,
  body: `"Cormorant Upright", serif;`,
  body_lv2: `"Cormorant Upright", serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    lineHeight: '1.6em',
    textAlign: 'center',
    color: 'mainColorText',
    textTransform: 'none',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    lineHeight: '1.2',
    color: 'secondaryColorText',
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
    textAlign: 'center',
  },
  body_lv2: {
    fontFamily: 'body_lv2',
    fontSize: 'body_lv2',
    fontWeight: 'body_lv2',
    fontStyle: 'var(--fontItalic-body_lv2)',
    color: 'mainColorText',
    textAlign: 'center',
  },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body_lv2,
  variant: 'solid',
  padding: '18px 24px',
  borderRadius: '40px',
  background: BUTTON_GRADIENT,
  color: 'white',
  size: 'sm',
  boxShadow: 'sm',
  fontStyle: 'italic',
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
